import { api } from './client';
import type { Page } from './catalogs';

export interface InventoryCountItem {
  id?: string;
  line_number: number;
  nomenclature_id: string;
  characteristic_id?: string | null;
  series_id?: string | null;
  book_quantity?: string;
  fact_quantity: string;
  variance_quantity?: string;
  book_amount?: string;
  fact_amount?: string;
}

export interface InventoryCountListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  warehouse_id: string;
  inventory_date: string;
  state: string;
  posted: boolean;
  deletion_mark: boolean;
  external_source?: string | null;
}

export interface InventoryCount extends InventoryCountListItem {
  posted_at: string | null;
  comment: string | null;
  items: InventoryCountItem[];
  // Block 5.3c:
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
}

export interface InventoryCountCreate {
  organization_id: string;
  document_number: string;
  document_date: string;
  warehouse_id: string;
  inventory_date: string;
  comment?: string | null;
  items: InventoryCountItem[];
}

export type InventoryCountUpdate = Partial<InventoryCountCreate>;

export const inventoryCounts = {
  list: (params?: {
    organization_id?: string;
    warehouse_id?: string;
    posted?: boolean;
    date_from?: string; date_to?: string;
    sort_by?: string; sort_dir?: 'asc' | 'desc';
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<InventoryCountListItem>>('/inventory-counts', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<InventoryCount>(`/inventory-counts/${id}`).then((r) => r.data),
  create: (payload: InventoryCountCreate) =>
    api.post<InventoryCount>('/inventory-counts', payload).then((r) => r.data),
  update: (id: string, payload: InventoryCountUpdate) =>
    api.patch<InventoryCount>(`/inventory-counts/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/inventory-counts/${id}`).then(() => undefined),
  /** 2026-08-11: створити рядки опису з УСІХ залишків складу. */
  fillFromStock: (id: string) =>
    api.post<InventoryCount>(`/inventory-counts/${id}/fill-from-stock`).then((r) => r.data),
  /** Статус: DRAFT ↔ IN_PROGRESS (опис у комісії). */
  setState: (id: string, state: 'DRAFT' | 'IN_PROGRESS') =>
    api.post<InventoryCount>(`/inventory-counts/${id}/set-state`, { state }).then((r) => r.data),
  recalcBook: (id: string) =>
    api.post<InventoryCount>(`/inventory-counts/${id}/recalc-book`).then((r) => r.data),
  post: (id: string) =>
    api.post<InventoryCount>(`/inventory-counts/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<InventoryCount>(`/inventory-counts/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/inventory-counts/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
